module.exports = __webpack_public_path__ + "img/icon-apple-google.3fab1b44.svg";